import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {I18n} from 'react-redux-i18n';
import firstBy from 'thenby';

import customer from '../../customer';
const {getActivePermissions, getUsePLUCode} = customer.selectors;

import {saveLabelToSheet} from '../actions';
import {getActiveLogo, getActivePageSize, getActivePetLabel, getFieldPositions, getSelectedGridIndex} from '../selectors';

import CloseButton from './CloseButton';
import LabelCol2Form from './LabelCol2Form';
import LabelCol4Form from './LabelCol4Form';
import LabelCol2LrgForm from './LabelCol2LrgForm';
import LabelCol4LrgForm from './LabelCol4LrgForm';

import * as permissions from '../../common/userPermissions';

const formName = 'editLabelForm';

class EditLabelPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldMapping: []
    };
  }

  componentWillMount() {
    const labelAccess = this.props.activePermissions.find((permission) => {
      return permission === permissions.ACCESS_LABELS;
    });
    if(!labelAccess)
    {
      this.props.actions.push('/labels');
    } 
    else if(this.props.selectedGridIndex < 0 || Object.keys(this.props.activePetLabel).length === 0) {
      this.props.actions.push('/labels');
    } else {
      const columns = this.props.fieldPositions.reduce((prev, current) => {
        return (prev.Column > current.Column) ? prev.Column : current.Column;
      });
      
      // Make sure the field positions are sorted properly
      let fieldPositions = this.props.fieldPositions;
      if(columns === 0) {
        fieldPositions.sort(firstBy("Column")
                                    .thenBy("Row"));
      } else if(columns === 1) {
        fieldPositions.sort(firstBy("Row")
                                    .thenBy("Column"));
      }

      // Sort the fields into the correct order
      let labelFields = [];
      fieldPositions.forEach((position) => {
        let labelField = this.props.activePetLabel.DetailFields.find((detailField) => {
          return detailField.Key === position.Field;
        });
        labelFields.push(labelField); 
      });
      
      // Build the mapping from the ordered fields
      let fieldMapping = [];
      labelFields.forEach((detailField, index) => {
        if(detailField !== undefined)
        {
          const keyName = `Key${index}`;
          const valueName = `Value${index}`;
          const mapping = {
            name: detailField.Key,
            key: keyName,
            value: valueName
          };
          fieldMapping.push(mapping);
        }
      });
      this.setState({fieldMapping: fieldMapping});
    }
  }

  handleFormCancel = () => {
    this.props.actions.push('/labels');
  }

  handleFormSubmit = (values) => {
    this.props.actions.saveLabelToSheet(this.props.activePageSize, this.props.activePetLabel, this.state.fieldMapping, this.props.activePLU, values);
  }

  render() {
    const {activeLogoUrl, activePageSize, activePetLabel, activePLU, fieldPositions} = this.props;
    const validLabel = Object.keys(activePetLabel).length !== 0;
    let large = false;
    if(activePageSize === '195 x 66 mm' || activePageSize == '91 x 130 mm' || activePageSize == '133 x 191 mm')
    {
      large = true;
    }

    let columns = -1;
    let labelFields = [];
    let initialValues = {};
    if(validLabel) {
      // We need the max column to select the proper label template
      columns = fieldPositions.reduce((prev, current) => {
        return (prev.Column > current.Column) ? prev.Column : current.Column;
      });

      // Sort the fields into the correct order
      fieldPositions.forEach((position) => {
        let labelField = activePetLabel.DetailFields.find((detailField) => {
          return detailField.Key === position.Field;
        });
        labelFields.push(labelField);
      });
      
      initialValues["line1"] = activePetLabel.Line1;
      initialValues["line2"] = activePetLabel.Line2;
      initialValues["plu"] = activePetLabel.PLUCode;
      initialValues["barcode"] = activePetLabel.Barcode;
      initialValues["pluKey"] = activePetLabel.PLUCodeTitle;
      initialValues["price"] = activePetLabel.Price;

      labelFields.forEach((detailField, index) => {
        if(detailField !== undefined)
        {
          const keyName = `Key${index}`;
          const valueName = `Value${index}`;
          initialValues[keyName] = detailField.OverwrittenKey;
          initialValues[valueName] = detailField.OverwrittenValue;
        }  
      });
    }

    return (
      <div id="wrapper"> 
        <div className="container-fluid main full-width" id="main">
          <div className="row">
            <div className="col-lg-12">
              <h1 className="float-left">{I18n.t('EDIT_LABEL')}</h1>
              <CloseButton url="/labels"/>
            </div>
          </div>
          {!validLabel && <div className="loading"/>}
          {(validLabel && columns === 0 && large == false) && <LabelCol2Form activePLU={activePLU}
                                        detailFields={labelFields}
                                        form={formName}
                                        initialValues={initialValues}
                                        logoUrl={activeLogoUrl}
                                        onSubmit={this.handleFormSubmit}
                                        petLabel={activePetLabel}
                                        submitButtonText={I18n.t('SAVE_LABEL')}
                                        onCancel={this.handleFormCancel}
          />}
          {(validLabel && columns === 0 && large == true) && <LabelCol2LrgForm activePLU={activePLU}
                                        detailFields={labelFields}
                                        form={formName}
                                        initialValues={initialValues}
                                        logoUrl={activeLogoUrl}
                                        onSubmit={this.handleFormSubmit}
                                        petLabel={activePetLabel}
                                        submitButtonText={I18n.t('SAVE_LABEL')}
                                        onCancel={this.handleFormCancel}
          />}
          {(validLabel && columns === 1 && large === false) && <LabelCol4Form activePLU={activePLU}
                                        detailFields={labelFields}
                                        form={formName}
                                        initialValues={initialValues}
                                        logoUrl={activeLogoUrl}
                                        onSubmit={this.handleFormSubmit}
                                        petLabel={activePetLabel}
                                        submitButtonText={I18n.t('SAVE_LABEL')}
                                        onCancel={this.handleFormCancel}
          />}
          {(validLabel && columns === 1 && large === true) && 
            <LabelCol4LrgForm activePLU={activePLU}
                              detailFields={labelFields}
                              form={formName}
                              initialValues={initialValues}
                              logoUrl={activeLogoUrl}
                              onSubmit={this.handleFormSubmit}
                              petLabel={activePetLabel}
                              submitButtonText={I18n.t('SAVE_LABEL')}
                              onCancel={this.handleFormCancel}
            />
          }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    activeLogoUrl: getActiveLogo(state),
    activePageSize: getActivePageSize(state),
    activePetLabel: getActivePetLabel(state),
    activePermissions: getActivePermissions(state),
    activePLU: getUsePLUCode(state),
    fieldPositions: getFieldPositions(state),
    selectedGridIndex: getSelectedGridIndex(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({push, saveLabelToSheet}, dispatch)
  };
}

EditLabelPage.propTypes = {
  actions: PropTypes.object.isRequired,
  activeLogoUrl: PropTypes.string.isRequired,
  activePageSize: PropTypes.string.isRequired,
  activePetLabel: PropTypes.object.isRequired,
  activePermissions: PropTypes.array.isRequired,
  activePLU: PropTypes.bool.isRequired,
  fieldPositions: PropTypes.array.isRequired,
  selectedGridIndex: PropTypes.number.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(EditLabelPage);


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/EditLabelPage.js
 **/